import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import addMessages from './editClassAddConfirmationMessages';
import editMessages from './editClassEditConfirmationMessages';
import { Modal } from 'sa-ui/';
import ModalType from './editClassModalType';

function getMessages(type) {
  switch (type) {
    case ModalType.ADD:
      return addMessages;
    case ModalType.EDIT:
      return editMessages;
    default:
      return addMessages;
  }
}

const EditClassConfirmationModal = props => {
  const messages = getMessages(props.type);
  if (!messages) throw new Error('sem message');
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="ti-thumb-up"
      title={<FormattedMessage {...messages.title} />}
      subtitle={<FormattedMessage {...messages.subtitle} />}
      buttons={[
        {
          label: <FormattedMessage {...messages.continue} />,
          onClick: props.onContinue,
        },
      ]}
    />
  );
};

EditClassConfirmationModal.propTypes = {};

EditClassConfirmationModal.defaultProps = {
  type: ModalType.ADD,
};

export default EditClassConfirmationModal;
